/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "photo-9aff724a--sprite",
  "use": "photo-9aff724a--sprite-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"photo-9aff724a--sprite\">\n  <defs></defs>\n  <path fill=\"none\" d=\"M30 0A30 30 0 110 30 30 30 0 0130 0z\" />\n  <g fill=\"currentColor\">\n    <path d=\"M44.2 16H16a.8.8 0 00-.8.8v26.7a.8.8 0 00.8.8h28.2a.8.8 0 00.7-.8V16.8a.8.8 0 00-.7-.8zm-1.9 8.9l-8.1 8a1.9 1.9 0 01-1.4.7 2 2 0 01-1.4-.6 2 2 0 00-2.7 0l-5.5 5.5h-4.6a.8.8 0 01-.8-.8V19.5a.8.8 0 01.8-.7h23a.8.8 0 01.7.7z\" />\n    <path d=\"M27.2 24.8a3.4 3.4 0 01-3.5 3.4 3.4 3.4 0 01-3.3-3.4 3.4 3.4 0 013.3-3.4 3.4 3.4 0 013.5 3.4z\" />\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
